/**
 * Нормализация URL вложений условия задачи (тот же origin, в dev Vite проксирует /media).
 */
export function resolveStatementAttachmentHref(url) {
  if (typeof url !== 'string' || !url.trim()) return '';
  const u = url.trim();
  if (u.startsWith('http://') || u.startsWith('https://')) return u;
  if (u.startsWith('/')) return u;
  return `/${u.replace(/^\//, '')}`;
}

export function attachmentDisplayName(att) {
  if (att && typeof att.name === 'string' && att.name.trim()) return att.name.trim();
  const u = typeof att?.url === 'string' ? att.url.trim() : '';
  if (!u) return 'файл';
  const tail = u.split('/').filter(Boolean).pop() || 'файл';
  return tail;
}
